$(document).ready(function () {

    // accordion
    let $sectionPanelCollapse = $('.section-faq .panel-collapse');
    $sectionPanelCollapse.on('show.bs.collapse', function () {
        $(this).parent().addClass('opened');
    });
    $sectionPanelCollapse.on('hide.bs.collapse', function () {
        $(this).parent().removeClass('opened');
    });

});

